var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgKey = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.5C7.83333 15.5 8.54167 15.2083 9.125 14.625C9.70833 14.0417 10 13.3333 10 12.5C10 11.6667 9.70833 10.9583 9.125 10.375C8.54167 9.79167 7.83333 9.5 7 9.5C6.16667 9.5 5.45833 9.79167 4.875 10.375C4.29167 10.9583 4 11.6667 4 12.5C4 13.3333 4.29167 14.0417 4.875 14.625C5.45833 15.2083 6.16667 15.5 7 15.5ZM7 18.5C5.33333 18.5 3.91667 17.9167 2.75 16.75C1.58333 15.5833 1 14.1667 1 12.5C1 10.8333 1.58333 9.41667 2.75 8.25C3.91667 7.08333 5.33333 6.5 7 6.5C8.35 6.5 9.52933 6.88333 10.538 7.65C11.5467 8.41667 12.2507 9.36667 12.65 10.5H21.025L23 12.475L19.5 16.475L17 14.5L15 16.5L13 14.5H12.65C12.2333 15.7 11.5083 16.6667 10.475 17.4C9.44167 18.1333 8.28333 18.5 7 18.5Z",
    fill: "#955CFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/key.0cb2a006.svg";
export { ForwardRef as ReactComponent };